import { put } from 'redux-saga/effects';
import {
    delegateAlertFail,
    delegateAlertSuccess,
    fetchDelegateTeamsFail,
    fetchDelegateTeamsSuccess
} from './actions';
import { delegateAlert, getDelegateTeams } from './backend';
import {
    makeErrorPayload,
    makeSuccessPayload
} from '../../../../../shared/helpers/payload.helper';
import {
    setErrorToast,
    setSuccessToast
} from '../../../../../shared/toast/redux/actions';

export function* delegateAlertSaga(action) {
    try {
        const { alertId, teamIds } = action.payload;
        const response = yield delegateAlert(alertId, teamIds);

        yield put(delegateAlertSuccess(response.data));
        yield put(
            setSuccessToast(
                makeSuccessPayload(
                    'Alert "' + alertId + '" delegated successfully.'
                )
            )
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(delegateAlertFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* fetchDelegateTeamsSaga() {
    try {
        const response = yield getDelegateTeams();

        yield put(fetchDelegateTeamsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchDelegateTeamsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
